import axios from 'axios'

export default {
    state: {
        sensitiveWords: {
            init:true
        }
    },
    getters: {

    },
    mutations: {
        setSensitiveWords (state, n){
            state.sensitiveWords = n;
        }
    },
    actions: {
        getSensitiveWords ({ commit, state }) {
            //如果还是初始状态 请求接口获取敏感词数据  如果已经请求过  直接返回数据
            return new Promise((resolve, reject) => {
                
                axios.get('/api/minganci/getCiKu.json', {
                    
                }).then(({status, data}) => {
                    if(status === 200 || status === '200') {
                        if(data.code === 'v') {
                            commit('setSensitiveWords', data.tdata);
                            resolve();
                        }
                    }
                });
            })
        }
    }
}
